<template>
  <div class="content">
    <van-nav-bar @click-left="onClickLeft">
      <template #left>
        <img style="width: 2.66667vw;height: 5.33333vw;display: inline-block;" :src="require('../../assets/'+appTheme+'/navBack.png')" alt="" />
      </template>
    </van-nav-bar>
    <van-address-list
      v-model="chosenAddressId"
      :list="list"
      add-button-text="编辑地址"
      default-tag-text="默认"
      @add="onAdd"
    />
  </div>
</template>

<script>
import { addressList } from '@/api/goods'
export default {
  name: "selectAddress",
  data() {
    return {
      appTheme:this.$store.state.appTheme,
      chosenAddressId: '1',
      list: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList(){
      var that = this
      addressList().then(res => {
        if(res.code == 200)
        {
          console.log('res',res.data.data)
          var arr = res.data.data
          var arrSec = JSON.parse(JSON.stringify(arr).replace(/phone/g,'tel').replace(/is_default/g,'isDefault'))
          this.list = arrSec
        }
        else
        {
          this.$toast(res.message)
          this.$router.push('/');
        }
      })
    },
    onClickLeft() {
      this.$router.go(-1);
    },
  }
}
</script>

<style lang="scss" scoped>
.van-nav-bar {
  background: #FDD80D;color: #333333;font-weight: bold;font-size: 30px;
}
.van-nav-bar .van-icon {
  color: #333333;
}
.van-address-item .van-radio__icon--checked .van-icon {
  background-color: #FDD80D;
  border-color: #FDD80D;
}
.van-button--danger {
  color: #282828;
  background-color: #FDD80D;
  border: 0.02667rem solid #FDD80D;
}
.van-tag--round {
  border-radius: 2px;padding:2px 8px; line-height: auto;
}

</style>
